import { IS_DEVELOP, DOMAIN, TOKEN_COOKIE_NAME } from "@/config";

type Cookies = "locale" | "token" | "demoToken";

export function getTokenFromCookie(): string | null {
  return getCookie(TOKEN_COOKIE_NAME);
}

export function getLocaleFromCookie(): string | null {
  return getCookie("locale"); // or whatever name you used
}

function getCookie(name: Cookies): string | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
  }
  return null;
}

export function hasTokenCookie(): boolean {
  return getCookie(TOKEN_COOKIE_NAME) !== null;
}

function getCookieDomain(): string | null {
  if (IS_DEVELOP) {
    return null;
  }

  return `.${DOMAIN}`;
}

export function setTokenCookie(token: string, days = 7) {
  setCookie(TOKEN_COOKIE_NAME, token, days);
}

export function setLocaleCookie(locale: string, days = 7) {
  setCookie("locale", locale, days);
}

export function setCookie(name: Cookies, value: string, days = 7) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  const domain = getCookieDomain();
  if (IS_DEVELOP || domain === null) {
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; secure; samesite=lax`;
  } else {
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; domain=${domain}; secure; samesite=lax`;
  }
}

function deleteCookie(name: Cookies): void {
  const domain = getCookieDomain();

  if (domain === null) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    return;
  }
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
}

export function clearTokenCookie() {
  deleteCookie(TOKEN_COOKIE_NAME);
}
export function clearLocaleCookie() {
  deleteCookie("locale");
}
